export const companyGovernmentAllocationDocumentRequiredOptions = [
  { label: 'Anexar documento', value: 'attach_document' },
  { label: 'Anexar documento posteriormente', value: 'bypass_file_presence' },
  { label: 'Empenho Tcard (não necessita documento e aprovação)', value: 'force_post_paid' },
]
